import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function initGsapFullscreenPagesCtaV2() {
    // Media query to match exactly the CSS behavior
    const isDesktop = "(min-width: 1500px) and (hover: hover)";
    const isMobileOrTouch = "(max-width: 1499px), (hover: none)";

    ScrollTrigger.matchMedia({
        [isDesktop]: function () {
            const sections = document.querySelectorAll("[data-gsap-fullscreen-v2]");

            sections.forEach((section) => {
                const tracks = section.querySelectorAll(".fullscreen-pages-cta-v2__track-wrapper");
                if (tracks.length <= 1) return;

                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: "top top",
                        end: () => `+=${window.innerHeight * (tracks.length + 1)}`,
                        scrub: 1,
                        pin: true,
                        pinSpacing: true,
                    }
                });

                tracks.forEach((track, index) => {
                    const title = track.querySelector(".js-cta-v2-title");
                    const image = track.querySelector(".js-cta-v2-image");
                    const content = track.querySelector(".js-cta-v2-content");

                    if (index === 0) {
                        gsap.set([title, image, content], {
                            y: 0,
                            autoAlpha: 1
                        });
                        return;
                    }

                    // Initial state for subsequent tracks
                    gsap.set(track, {
                        zIndex: 10 + index
                    });

                    gsap.set([title, image, content], {
                        y: 100,
                        autoAlpha: 0
                    });

                    // Animation logic
                    if (index > 0) {
                        const prevTrack = tracks[index - 1];
                        tl.to([
                            prevTrack.querySelector(".js-cta-v2-title"),
                            prevTrack.querySelector(".js-cta-v2-image"),
                            prevTrack.querySelector(".js-cta-v2-content")
                        ], {
                            y: -100,
                            autoAlpha: 0,
                            duration: 1,
                            stagger: 0.1,
                            ease: "power2.in"
                        });
                    }

                    tl.to([title, image, content], {
                        y: 0,
                        autoAlpha: 1,
                        duration: 1,
                        stagger: 0.1,
                        ease: "power2.out"
                    }, "-=0.5");
                });
            });
        },
        [isMobileOrTouch]: function () {
            const sections = document.querySelectorAll("[data-gsap-fullscreen-v2]");
            sections.forEach((section) => {
                const tracks = section.querySelectorAll(".fullscreen-pages-cta-v2__track-wrapper");

                // Full reset
                gsap.set(section, { height: "auto", clearProps: "all" });

                tracks.forEach((track) => {
                    const title = track.querySelector(".js-cta-v2-title");
                    const image = track.querySelector(".js-cta-v2-image");
                    const content = track.querySelector(".js-cta-v2-content");

                    gsap.set(track, { clearProps: "all" });

                    // Simple Reveal Animation for Mobile
                    gsap.fromTo([title, image, content],
                        {
                            y: 30,
                            autoAlpha: 0
                        },
                        {
                            y: 0,
                            autoAlpha: 1,
                            duration: 1,
                            stagger: 0.15,
                            ease: "power2.out",
                            scrollTrigger: {
                                trigger: track,
                                start: "top 85%",
                                toggleActions: "play none none none"
                            }
                        }
                    );
                });
            });
        }
    });
}
